export const DEMO_MODE_SELECT_OG_IMAGE_PATH = '/og/IBOG1.jpg';
export const DEMO_MODE_SELECT_OG_IMAGE_URL = `https://innerbloomjourney.org${DEMO_MODE_SELECT_OG_IMAGE_PATH}`;
export const DEMO_MODE_SELECT_OG_IMAGE_TYPE = 'image/jpeg';
export const DEMO_MODE_SELECT_OG_IMAGE_WIDTH = '1200';
export const DEMO_MODE_SELECT_OG_IMAGE_HEIGHT = '630';
